import { render, staticRenderFns } from "./bill.customer.detail.vue?vue&type=template&id=f2ed25c0&scoped=true&"
import script from "./bill.customer.detail.vue?vue&type=script&lang=js&"
export * from "./bill.customer.detail.vue?vue&type=script&lang=js&"
import style0 from "./bill.customer.detail.vue?vue&type=style&index=0&id=f2ed25c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ed25c0",
  null
  
)

export default component.exports